import { ApplicationInsights } from '@microsoft/applicationinsights-web';

class TelemetryService {
    appInsights: ApplicationInsights;

    async initialize() {
        await fetch('/api/config/app-insights/instrumentation-key')
            .then(response => response.json())
            .then(response => {
                var instrumentationKey = response.appInsightsInstrumentationKey;

                if (!instrumentationKey) {
                    throw new Error('Could not initialize Telemetry Service');
                }

                this.appInsights = new ApplicationInsights({
                    config: {
                        instrumentationKey,
                        maxBatchInterval: 0,
                        enableCorsCorrelation: true,
                        disableFetchTracking: false
                    }
                });

                this.appInsights.loadAppInsights();
            });
    }

    constructor() {
        this.appInsights = new ApplicationInsights({ config: {} });
        this.initialize();
    }
}

const ai = new TelemetryService();

export { ai };
